import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';

const Footer = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Back to Top Button */}
      <button 
        className={`back-to-top ${showBackToTop ? 'show' : ''}`}
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        <i className="fas fa-chevron-up"></i>
      </button>

      <div className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s">
        <div className="container py-5">
          <div className="row g-5">
            {/* About Us Column */}
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <div className="footer-item">
                  <h4 className="text-white mb-4">About Outlook Digital</h4>
                  <p className="mb-4">
                    Outlook Digital Solutions is a leading provider of innovative technology solutions,
                    specializing in interactive panels, sound systems, and computers. We enhance user 
                    experiences through cutting-edge digital solutions tailored to meet client needs.
                  </p>
                  <div className="company-badge bg-primary rounded-pill px-3 py-2 d-inline-block">
                    <small className="text-white fw-bold">
                      <i className="fas fa-award me-1"></i>Trusted Since 2007
                    </small>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links Column */}
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">Quick Links</h4>
                <Link to="/">
                  <i className="fas fa-home me-2"></i> Home
                </Link>
                <Link to="/about">
                  <i className="fas fa-info-circle me-2"></i> About Us
                </Link>
                <Link to="/services">
                  <i className="fas fa-cogs me-2"></i> Our Services
                </Link>
                <Link to="/projects">
                  <i className="fas fa-briefcase me-2"></i> Projects
                </Link>
                <Link to="/contact">
                  <i className="fas fa-envelope me-2"></i> Contact Us
                </Link>
                <Link to="/core-values">
                  <i className="fas fa-star me-2"></i> Core Values
                </Link>
              </div>
            </div>

            {/* Business Hours Column */}
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">Business Hours</h4>
                <div className="business-hours-item">
                  <h6 className="mb-1">Saturday - Thursday:</h6>
                  <p className="mb-0">09:00 AM to 05:00 PM</p>
                </div>
             
                <div className="business-hours-item">
                  <h6 className="mb-1">Friday:</h6>
                  <p className="mb-0">Weekly Vacation</p>
                </div>
                <div className="business-hours-item">
                  <h6 className="mb-1">Emergency Support:</h6>
                  <p className="mb-0">24/7 Available</p>
                </div>
              </div>
            </div>

            {/* Contact Info Column */}
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className="text-white mb-4">Get In Touch</h4>
                
                <div className="contact-info-item">
                  <i className="fas fa-map-marker-alt"></i>
                  <span>
                    July 23 above Al-Tawhid, Al-Nour,<br />
                    Seventh Floor - Bani Suef
                  </span>
                </div>
                
                <div className="contact-info-item">
                  <i className="fas fa-envelope"></i>
                  <span>sales@outlookds.com</span>
                </div>
                
                <div className="contact-info-item">
                  <i className="fas fa-phone-alt"></i>
                  <span>01205450008</span>
                </div>
                
                <div className="contact-info-item">
                  <i className="fas fa-globe"></i>
                  <span>www.outlookds.com</span>
                </div>

                {/* Social Media */}
                <div className="social-media-wrapper">
                  <h6 className="text-white mb-3">Follow Us</h6>
                  <div className="d-flex">
                    <a className="social-btn rounded-circle me-3" href="https://www.facebook.com/share/1DJdbQXfGv/?mibextid=wwXIfr" aria-label="Facebook">
                      <i className="fab fa-facebook-f text-white"></i>
                    </a>
                    <a className="social-btn rounded-circle me-3" href="https://wa.me/+201205450008" aria-label="whatsapp">
                      <i className="fab fa-whatsapp text-white"></i>
                    </a>
                    <a className="social-btn rounded-circle me-3" href="https://www.instagram.com/outlook_ds?igsh=MXdmbm03bWxteDJkbw==" aria-label="Instagram">
                      <i className="fab fa-instagram text-white"></i>
                    </a>
                    <a className="social-btn rounded-circle" href="https://www.linkedin.com/company/outlookds/" aria-label="LinkedIn">
                      <i className="fab fa-linkedin-in text-white"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom mt-5 pt-4 border-top border-secondary">
            <div className="row align-items-center">
              <div className="col-md-6 text-center text-md-start">
                <p className="mb-0">
                  &copy; 2024 Outlook Digital Solutions. All Rights Reserved.
                </p>
              </div>
          
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;